"use client"

import PortableTextRenderer from "@/app/(site)/_components/Atoms/PortableTextRenderer/PortableTextRenderer"
import StoryText from "@/app/(site)/_components/Atoms/Storytext"
import Text from "@/app/(site)/_components/Atoms/Text"
import { type Content } from "@/app/(site)/_components/ContentMapper"
import React from "react"
import type { PortableTextBlock } from "sanity"

export interface BulletPointListBlockData {
    _type?: "bulletPointListBlock"
    title: string
    list: {
        title: string
        description?: PortableTextBlock[]
    }[]
}

export interface BulletPointListProps extends Content {
    data: BulletPointListBlockData
}

const BulletPointListBlock: React.FC<BulletPointListProps> = ({ data }) => {
    return (
        <section
            className="mx-16 border-t-2 border-black py-32 md:mx-24 md:py-56"
            id={"bulletpoint"}
        >
            <div className="grid grid-cols-2 pb-32 pt-24 md:pb-72">
                <div>
                    {data?.title && (
                        <div className="font-trimLightNew text-32 font-300 uppercase leading-110 tracking-[-2.4px] md:text-48 md:tracking-[-1.3px]">
                            {data.title}
                        </div>
                    )}
                </div>
            </div>
            <>
                <div className="mb-24 md:mb-72">
                    <div className="grid grid-cols-3 gap-24 md:justify-items-end">
                        {/* 3 Column Row */}
                        <div className="col-span-3 mt-24 md:col-[2/-1] md:mt-0">
                            {/* 2 Column  */}
                            <div className="grid grid-cols-1 gap-0 md:grid-cols-2 md:gap-24">
                                {data.list?.map((bulletPoint, index) => {
                                    const title = bulletPoint?.title
                                    const description = bulletPoint?.description
                                    return (
                                        <div
                                            key={index}
                                            className="col-span-1 grid grid-cols-2 border-t border-black pb-24 pt-12 md:pb-48 md:pt-8"
                                        >
                                            {title && (
                                                <div className="col-span-2 mb-12 sm:col-span-1 md:mb-0">
                                                    <Text size="medium" weight="regular">
                                                        {title}
                                                    </Text>
                                                </div>
                                            )}

                                            {!!description && (
                                                <PortableTextRenderer
                                                    content={description}
                                                    render={{
                                                        block: {
                                                            normal: text => (
                                                                <StoryText
                                                                    size="size4"
                                                                    className="col-span-2 sm:col-span-1"
                                                                >
                                                                    {text}
                                                                </StoryText>
                                                            )
                                                        }
                                                    }}
                                                />
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </section>
    )
}

export default BulletPointListBlock
